import React from "react";
import Marquee from "react-fast-marquee";

// Tes icônes / images
import mongodb from "../../assets/img/ico/mongodb.svg";
import mysql from "../../assets/img/ico/mysql.svg";
import tailwind from "../../assets/img/ico/tailwind.svg";
import visualStudioCode from "../../assets/img/ico/visualStudioCode.svg";
import flutter from "../../assets/img/ico/flutter.svg";
import wordpress from "../../assets/img/ico/wordpress.svg";
import php from "../../assets/img/ico/php.svg";
import gitlab from "../../assets/img/ico/gitlab.svg";
import docker from "../../assets/img/ico/docker.svg";
import git from "../../assets/img/ico/git.svg";
import react from "../../assets/img/ico/react.svg";
import js from "../../assets/img/ico/js.svg";
import css from "../../assets/img/ico/css.svg";
import html from "../../assets/img/ico/html.svg";
import java from "../../assets/img/ico/java.svg";

// Import du fichier CSS (où on mettra le fade)
import "../../assets/css/skills.css";

const Skills = () => {
  // Mélange d'icônes Font Awesome et d'images
  const skills = [
    <img src={mongodb} alt="mongodb" />,
    <img src={mysql} alt="mysql" />,
    <img src={tailwind} alt="tailwind" />,
    <img src={visualStudioCode} alt="visualStudioCode" />,
    <img src={flutter} alt="flutter" />,
    <img src={wordpress} alt="wordpress" />,
    <img src={php} alt="php" />,
    <img src={gitlab} alt="gitlab" />,
    <img src={docker} alt="docker" />,
    <img src={git} alt="git" />,
    <img src={react} alt="react" />,
    <img src={js} alt="js" />,
    <img src={css} alt="css" />,
    <img src={html} alt="html" />,
    <img src={java} alt="java" />,
  ];

  return (
    <section className="skills-section" id="skills">
      <h2>Skills</h2>

      <div className="marquee-wrapper">
        {/* 
          Le composant Marquee gère le défilement infini
          gradient={false} => pas de gradient "intégré"
          speed={50}       => vitesse (ajuste si besoin)
          loop={0}         => 0 = infini
          direction="left" => sens du défilement (par défaut "left")
        */}
        <Marquee
          gradient={false}
          speed={75}
          loop={0}
          direction="left"
          pauseOnHover={false} // Optionnel: pause au survol
        >
          {skills.map((skill, idx) => (
            <div className="marquee-item" key={idx}>
              {skill}
            </div>
          ))}
        </Marquee>
      </div>
      <div className="skills-flex">
        {/* Carte 1 */}
        <div className="skills-card card-bleue">
          <span className="skills-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14.5 3.5C14.5 3.5 14.5 5.5 12 5.5C9.5 5.5 9.5 3.5 9.5 3.5H7.5L4.20711 6.79289C3.81658 7.18342 3.81658 7.81658 4.20711 8.20711L6.5 10.5V20.5H17.5V10.5L19.7929 8.20711C20.1834 7.81658 20.1834 7.18342 19.7929 6.79289L16.5 3.5H14.5Z" />
            </svg>
          </span>
          <h4>Front End</h4>
          <p>
            Je maîtrise divers frameworks modernes, optimisant l’expérience
            utilisateur et rendant chaque interface interactive, performante,
            réactive.
          </p>
          <div className="skills-shine"></div>
          <div className="skills-background">
            <div className="skills-tiles">
              <div className="skills-tile skills-tile-1"></div>
              <div className="skills-tile skills-tile-2"></div>
              <div className="skills-tile skills-tile-3"></div>
              <div className="skills-tile skills-tile-4"></div>
              <div className="skills-tile skills-tile-5"></div>
              <div className="skills-tile skills-tile-6"></div>
              <div className="skills-tile skills-tile-7"></div>
              <div className="skills-tile skills-tile-8"></div>
              <div className="skills-tile skills-tile-9"></div>
              <div className="skills-tile skills-tile-10"></div>
            </div>
            <div className="skills-line skills-line-1"></div>
            <div className="skills-line skills-line-2"></div>
            <div className="skills-line skills-line-3"></div>
          </div>
        </div>

        {/* Carte 2 */}
        <div className="skills-card card-verte">
          <span className="skills-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4.5 9.5V5.5C4.5 4.94772 4.94772 4.5 5.5 4.5H9.5C10.0523 4.5 10.5 4.94772 10.5 5.5V9.5C10.5 10.0523 10.0523 10.5 9.5 10.5H5.5C4.94772 10.5 4.5 10.0523 4.5 9.5Z" />
              <path d="M13.5 18.5V14.5C13.5 13.9477 13.9477 13.5 14.5 13.5H18.5C19.0523 13.5 19.5 13.9477 19.5 14.5V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5H14.5C13.9477 19.5 13.5 19.0523 13.5 18.5Z" />
              <path d="M4.5 19.5L7.5 13.5L10.5 19.5H4.5Z" />
              <path d="M16.5 4.5C18.1569 4.5 19.5 5.84315 19.5 7.5C19.5 9.15685 18.1569 10.5 16.5 10.5C14.8431 10.5 13.5 9.15685 13.5 7.5C13.5 5.84315 14.8431 4.5 16.5 4.5Z" />
            </svg>
          </span>
          <h4>Design UI</h4>
          <p>
            Ma conception visuelle valorise l'ergonomie, assurant l'identité
            graphique et guidant efficacement l'utilisateur dans ses actions.
          </p>
          <div className="skills-shine"></div>
          <div className="skills-background">
            <div className="skills-tiles">
              <div className="skills-tile skills-tile-1"></div>
              <div className="skills-tile skills-tile-2"></div>
              <div className="skills-tile skills-tile-3"></div>
              <div className="skills-tile skills-tile-4"></div>
              <div className="skills-tile skills-tile-5"></div>
              <div className="skills-tile skills-tile-6"></div>
              <div className="skills-tile skills-tile-7"></div>
              <div className="skills-tile skills-tile-8"></div>
              <div className="skills-tile skills-tile-9"></div>
              <div className="skills-tile skills-tile-10"></div>
            </div>
            <div className="skills-line skills-line-1"></div>
            <div className="skills-line skills-line-2"></div>
            <div className="skills-line skills-line-3"></div>
          </div>
        </div>
        <div className="skills-card card-rose">
          <span className="skills-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4.5 9.5V5.5C4.5 4.94772 4.94772 4.5 5.5 4.5H9.5C10.0523 4.5 10.5 4.94772 10.5 5.5V9.5C10.5 10.0523 10.0523 10.5 9.5 10.5H5.5C4.94772 10.5 4.5 10.0523 4.5 9.5Z" />
              <path d="M13.5 18.5V14.5C13.5 13.9477 13.9477 13.5 14.5 13.5H18.5C19.0523 13.5 19.5 13.9477 19.5 14.5V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5H14.5C13.9477 19.5 13.5 19.0523 13.5 18.5Z" />
              <path d="M4.5 19.5L7.5 13.5L10.5 19.5H4.5Z" />
              <path d="M16.5 4.5C18.1569 4.5 19.5 5.84315 19.5 7.5C19.5 9.15685 18.1569 10.5 16.5 10.5C14.8431 10.5 13.5 9.15685 13.5 7.5C13.5 5.84315 14.8431 4.5 16.5 4.5Z" />
            </svg>
          </span>
          <h4>Back End</h4>
          <p>
            J'implémente des solutions, gère l'intégrité des données et garantis
            une architecture évolutive assurant performance continue.
          </p>
          <div className="skills-shine"></div>
          <div className="skills-background">
            <div className="skills-tiles">
              <div className="skills-tile skills-tile-1"></div>
              <div className="skills-tile skills-tile-2"></div>
              <div className="skills-tile skills-tile-3"></div>
              <div className="skills-tile skills-tile-4"></div>
              <div className="skills-tile skills-tile-5"></div>
              <div className="skills-tile skills-tile-6"></div>
              <div className="skills-tile skills-tile-7"></div>
              <div className="skills-tile skills-tile-8"></div>
              <div className="skills-tile skills-tile-9"></div>
              <div className="skills-tile skills-tile-10"></div>
            </div>
            <div className="skills-line skills-line-1"></div>
            <div className="skills-line skills-line-2"></div>
            <div className="skills-line skills-line-3"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
